export const FEATURES = {
    LEADS: 1, // 2^0
    MATTERS: 2, // 2^1
    DISCOVERY: 4, // 2^2
    INTAKES: 8, // 2^3
    PAYROLL: 16 // 2^4
};

export const has = (flag) => {
    const features = Number(localStorage.getItem("features"));
    try {
        return Boolean((features) & flag);
    } catch (error) {
        return false;
    }
}